"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Icon_1 = require("./Icon");
const Link_1 = require("./Link");
const color_1 = require("../constants/color");
const intent_1 = require("../constants/intent");
const theme_1 = require("../constants/theme");
const create_styles_1 = require("../utils/create-styles");
const styled_system_1 = require("../utils/styled-system");
const COLOR_STYLE_MAP = {
    blue: {
        backgroundColor: color_1.Color.LIGHTEST_BLUE,
        color: color_1.Color.DARK_BLUE,
    },
    danger: {
        backgroundColor: (0, intent_1.getIntentProps)('danger').backgroundColor,
        color: (0, intent_1.getIntentProps)('danger').color,
    },
    'dark-blue': {
        backgroundColor: color_1.Color.DARK_BLUE,
        color: color_1.Color.WHITE,
    },
    'dark-green': {
        backgroundColor: color_1.Color.DARK_GREEN,
        color: color_1.Color.WHITE,
    },
    'dark-red': {
        backgroundColor: color_1.Color.DARK_RED,
        color: color_1.Color.WHITE,
    },
    'darker-green': {
        backgroundColor: color_1.Color.TRANSPARENT_GREEN,
        color: color_1.Color.DARKER_GREEN,
    },
    'lighter-green': {
        backgroundColor: color_1.Color.LIGHTER_GREEN,
        color: color_1.Color.DARK_GREY,
    },
    green: {
        backgroundColor: color_1.Color.TRANSPARENT_GREEN,
        color: color_1.Color.DARK_GREEN,
    },
    grey: {
        backgroundColor: color_1.Color.GREY,
        color: color_1.Color.DARK_GREY,
    },
    'light-blue': {
        backgroundColor: color_1.Color.LIGHTER_BLUE,
        color: color_1.Color.DARK_BLUE,
    },
    'medium-green': {
        backgroundColor: color_1.Color.GREEN,
        color: color_1.Color.WHITE,
    },
    'light-yellow': {
        backgroundColor: color_1.Color.LIGHT_YELLOW,
        color: color_1.Color.DARK_YELLOW,
    },
    violet: {
        backgroundColor: color_1.Color.TRANSPARENT_PURPLE,
        color: color_1.Color.VIOLET,
    },
    purple: {
        backgroundColor: color_1.Color.TRANSPARENT_PURPLE,
        color: color_1.Color.DEEP_PURPLE,
    },
    red: {
        backgroundColor: color_1.Color.LIGHTER_RED,
        color: color_1.Color.DARK_RED,
    },
    yellow: {
        backgroundColor: color_1.Color.YELLOW,
        color: color_1.Color.DARK_YELLOW,
    },
    white: {
        backgroundColor: color_1.Color.WHITE,
        borderColor: theme_1.theme.color.border,
        color: color_1.Color.BLACK,
    },
    transparent: {
        backgroundColor: color_1.Color.TRANSPARENT,
        color: color_1.Color.DARK_GREY,
        borderColor: color_1.Color.MEDIUM_GREY,
        fontWeight: theme_1.theme.font.weight.book,
    },
    'transparent-purple': {
        backgroundColor: color_1.Color.TRANSPARENT_PURPLE,
        color: color_1.Color.DARK_GREY,
    },
    'lighter-blue': {
        backgroundColor: color_1.Color.LIGHTER_BLUE,
        color: color_1.Color.DARK_GREY,
    },
    'golden-rod': {
        backgroundColor: color_1.Color.GOLDEN_ROD,
        color: color_1.Color.WHITE,
    },
    orange: {
        backgroundColor: color_1.Color.ORANGE,
        color: color_1.Color.CHARCOAL,
    },
};
const SIZE_STYLE_MAP = {
    xxxs: {
        fontSize: 8,
        paddingX: 3,
        paddingY: 1,
    },
    xxs: {
        fontSize: 12,
        paddingX: 4,
        paddingY: 0,
    },
    xs: {
        fontSize: theme_1.theme.font.size[6.5],
        paddingX: 6,
        paddingY: 0,
    },
    sm: {
        fontSize: theme_1.theme.font.size[6],
        paddingX: 6,
        paddingY: 1,
    },
    md: {
        fontSize: theme_1.theme.font.size[5],
        paddingX: 8,
        paddingY: 1,
    },
};
const BadgeElement = styled_1.default.div((props) => {
    const { backgroundColor, color, borderColor, fontWeight } = COLOR_STYLE_MAP[props.color ?? 'grey'];
    const { fontSize, paddingX, paddingY } = SIZE_STYLE_MAP[props.size ?? 'md'];
    return {
        alignItems: 'center',
        backgroundColor,
        border: `${theme_1.theme.border.width.thin}px solid ${borderColor ?? backgroundColor}`,
        borderRadius: props.pill
            ? 100
            : props.squared
                ? theme_1.theme.border.radius.normal
                : 12,
        color,
        cursor: props.cursor,
        display: 'inline-flex',
        fontSize,
        fontWeight: fontWeight ?? theme_1.theme.font.weight.bold,
        gridGap: 6,
        letterSpacing: props.uppercase ? '0.05rem' : undefined,
        lineHeight: 1.3,
        paddingBottom: paddingY,
        paddingLeft: paddingX,
        paddingRight: paddingX,
        paddingTop: paddingY,
        textAlign: 'center',
        textDecoration: 'none',
        textTransform: props.uppercase ? 'uppercase' : undefined,
        userSelect: 'none',
        ...(borderColor && { borderColor }),
        ...(0, styled_system_1.space)(props),
        ...(0, create_styles_1.createStyles)(props.styles),
    };
});
const Badge = (props) => {
    const isRight = props.iconPosition === 'right';
    const badgeElement = ((0, jsx_runtime_1.jsxs)(BadgeElement, { ...props, size: props.size, children: [props.icon && !isRight && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: props.icon, size: "sm" }), props.children, props.icon && isRight && (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: props.icon, size: "sm" })] }));
    return props.to ? ((0, jsx_runtime_1.jsx)(Link_1.Link, { styles: { display: 'inherit' }, to: props.to, children: badgeElement })) : (badgeElement);
};
exports.Badge = Badge;
